import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"
import MaxWidthContainer from "@components/Layout/MaxWidthContainer"
import MaxWidthContent from "@components/Layout/MaxWidthContent"
import Dropdown from "@components/Dropdown"
import { SortMethods } from "@views/common"
import { MobileOnly } from "@utils/MediaQueries"
import Link from "next/link"
import colors from "@constants/colors"
import { body } from "@constants/typography"

const Container = styled.div`
  padding: 0 16px;

  ${up("laptop")} {
    padding: 0;
    width: 364px;
  }

  &.gallery-link {
    ${up("laptop")} {
      display: none;
    }

    a {
      ${body}
      align-items: center;
      display: flex;
      margin: 0;
      padding: 10px 24px;
      outline: none;
      border: 1px solid ${colors.divider};
      border-radius: 2px;
      box-sizing: border-box;
      background: ${"none"};
      cursor: pointer;
      color: ${colors.obsidian};
    }
  }
`

const options = [
  {
    label: "Featured",
    value: SortMethods.ByFeatured,
  },
  {
    label: "Price Low to High",
    value: SortMethods.ByPriceAsc,
  },
  {
    label: "Price High to Low",
    value: SortMethods.ByPriceDesc,
  },
  {
    label: "Name A to Z",
    value: SortMethods.ByNameAsc,
  },
  {
    label: "Name Z to A",
    value: SortMethods.ByNameDesc,
  },
]

const SortDropdown: any = ({
  value,
  onSort,
  galleryLink = undefined,
  clearanceLink = undefined,
}) => {
  return (
    <MaxWidthContainer noMobilePadding>
      {galleryLink || clearanceLink ? (
        <>
          <MaxWidthContent
            cols={6}
            style={{
              zIndex: 1,
              alignItems: "center",
              justifyContent: "flex-start",
              display: "flex",
            }}
          >
            <Container className="gallery-link">
              {galleryLink ? (
                <Link href={galleryLink} passHref>
                  View Gallery
                </Link>
              ) : (
                ""
              )}
              {clearanceLink ? (
                <>
                  <div style={{ height: "16px" }}></div>
                  <Link href={clearanceLink} passHref>
                    Clearance
                  </Link>
                </>
              ) : (
                ""
              )}
            </Container>
          </MaxWidthContent>
          <MaxWidthContent
            cols={6}
            style={{
              zIndex: 1,
              alignItems: "center",
              justifyContent: "flex-end",
              display: "flex",
            }}
          >
            <Container>
              <Dropdown
                helperText="Sort By:"
                value={value}
                options={options}
                onChange={(option) => {
                  onSort(option.value)
                }}
              />
            </Container>
          </MaxWidthContent>
        </>
      ) : (
        <MaxWidthContent
          cols={12}
          style={{
            zIndex: 1,
            alignItems: "center",
            justifyContent: "flex-end",
            display: "flex",
          }}
        >
          <Container>
            <Dropdown
              helperText="Sort By:"
              value={value}
              options={options}
              onChange={(option) => {
                onSort(option.value)
              }}
            />
          </Container>
        </MaxWidthContent>
      )}
    </MaxWidthContainer>
  )
}

export default SortDropdown
